import './NoOrdersEmptyState.scss';

export const NO_ORDER_COPY =
  "There isn't an order for this individual. Once an order is placed, it'll appear here, and you'll be able to track order progress and download results.";

export const NoOrdersEmptyState = () => (
  <section className='no-orders'>
    <h2 className='no-orders__heading'>Orders</h2>
    <div className='no-orders__tile'>
      <p className='no-orders__body'>{NO_ORDER_COPY}</p>
    </div>
  </section>
);
